import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'a-checkbox',
  templateUrl: 'a-checkbox.component.html',
  styleUrls: ['a-checkbox.component.scss']
})
export class ACheckboxComponent {

  @Input() label = '';
  @Input() isDisabled = false;
  @Input() isSubmitted = false;
  @Input() control = new FormControl;
  @Input() set value(val) {
    this.control.setValue(val);
  };
  @Output() onChanged = new EventEmitter<boolean>();

  constructor() {
  }

  onChange(e: any) {
    this.control.setValue(e.target.checked);
    this.onChanged.emit(e.target.checked);
  }

}
